export const roundLayoutSize = size => Math.round(size * 1000) / 1000;
//# sourceMappingURL=roundLayoutSize.js.map